import { Alert } from "antd";
import { useTranslation } from "react-i18next";

import { CompanyType } from "@/v1/types";

interface UnsupportedRechtsformHintProps {
  companyType?: CompanyType | null;
}

/**
 * Shown instead of the FsE form when the Mandant's Rechtsform has no form yet,
 * or none is recorded. Never falls back to the Einzelunternehmer form: filing
 * the wrong ELSTER Datenart is only caught by the Finanzamt.
 */
export const UnsupportedRechtsformHint = ({
  companyType,
}: UnsupportedRechtsformHintProps) => {
  const { t } = useTranslation("TaxRegistration");

  return (
    <Alert
      data-test="unsupportedRechtsformHint"
      description={
        companyType
          ? t("rechtsform.unsupportedDescription", { companyType })
          : t("rechtsform.missingDescription")
      }
      message={
        companyType
          ? t("rechtsform.unsupportedTitle")
          : t("rechtsform.missingTitle")
      }
      showIcon
      type="info"
    />
  );
};
